<template>
  <div data-testid="site-unidades-page">
    <div style="margin-bottom: 20px;">
      <Button
        :label="t('Adicionar Unidade')"
        icon="pi pi-plus"
        size="small"
        data-testid="site-unidades-add-button"
        @click="handleNew"
      />
    </div>

    <!-- SiteUnidades Table -->
    <site-unidades-table
      ref="siteUnidadesTableRef"
      @edit="handleEdit"
      @delete="handleDelete">
    </site-unidades-table>

    <!-- SiteUnidadesModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import SiteUnidadesTable from './SiteUnidadesTable.vue';
import { eventBus } from '../../eventBus';
// SiteUnidadesModal is centralized in ModalManager.vue
import { log } from '../../utils/DebugLogger';

type UnidadeId = number | string;

interface UnidadeRecord {
  id?: number;
  slug?: string;
  nome?: Record<string, string>;
  [key: string]: unknown;
}

interface SiteUnidadesTableInstance {
  loadData: () => void | Promise<void>;
}

withDefaults(defineProps<{
  translations?: Record<string, unknown>;
}>(), {
  translations: () => ({})
});

const { t } = useI18n();

const siteUnidadesTableRef = ref<SiteUnidadesTableInstance | null>(null);

const loadData = async (): Promise<void> => {
  log('SiteUnidadesPage', 'loadData', 'Reloading data');
  if (siteUnidadesTableRef.value) {
    await siteUnidadesTableRef.value.loadData();
  }
};

const handleNew = (): void => {
  log('SiteUnidadesPage', 'handleNew', 'Opening modal for new unit via eventBus');
  eventBus.emit('modal.site-unidades.open', { action: 'create' });
};

const handleEdit = (unidadeId?: UnidadeId): void => {
  log('SiteUnidadesPage', 'handleEdit', 'Editing unit ID via eventBus', unidadeId);
  if (unidadeId === undefined) return;
  eventBus.emit('modal.site-unidades.open', { id: unidadeId, action: 'edit' });
};

const handleDelete = (unidadeId?: UnidadeId, unidadeData: UnidadeRecord | null = null): void => {
  log('SiteUnidadesPage', 'handleDelete', 'Deleting unit ID via eventBus', unidadeId);
  if (unidadeId === undefined) return;
  eventBus.emit('modal.site-unidades.open', { id: unidadeId, data: unidadeData, action: 'delete' });
};

onMounted(() => {
  log('SiteUnidadesPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('SiteUnidadesPage', 'beforeUnmount', 'Cleaning up');
});

defineExpose({
  loadData,
  handleNew,
  handleEdit,
  handleDelete
});
</script>

<style scoped>
</style>
